import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Fields } from '../models/fields';
import { BaseService } from './base-service.service';
import { ReassignFields } from '../models/reassign-fields';

@Injectable({
  providedIn: 'root'
})
export class FieldsService extends BaseService {
  constructor(private http: HttpClient) { super(); }

  save(field: Fields, id?: number): Observable<any> {
    if (id == null) {
      return this.http.post<Fields>(`${this.getUrl('Fields')}`, field);
    } else {
      return this.http.put<Fields>(`${this.getUrl('Fields')}/${id}`, field);
    }
  }

  reassign(field: ReassignFields): Observable<any> {
    return this.http.post<Fields>(`${this.getUrl('Fields/reassign')}`, field);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.getUrl('Fields')}/${id}`);
  }

  exportPolygon(id: number): Observable<any> {
    return this.http.delete(`${this.getUrl('Fields')}/${id}`);
  }
}
